import { render, staticRenderFns } from "./FollowTask.vue?vue&type=template&id=5e646565&"
import script from "./FollowTask.vue?vue&type=script&lang=js&"
export * from "./FollowTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports